import React from "react";
import styled from "styled-components";

const TermsContainer = styled.div`
    min-height: 100vh;
    background: white;
    padding: 4rem 0;
`;

const TermsContent = styled.div`
    max-width: 800px;
    margin: 0 auto;
    padding: 0 20px;

    @media (max-width: 768px) {
        padding: 0 15px;
    }
`;

const TermsTitle = styled.h1`
    font-size: 2.5rem;
    font-weight: 600;
    margin-bottom: 2rem;
    color: #333;
    text-align: center;

    @media (max-width: 768px) {
        font-size: 2rem;
        margin-bottom: 1.5rem;
    }
`;

const TermsSection = styled.section`
    margin-bottom: 2rem;
`;

const SectionTitle = styled.h2`
    font-size: 1.5rem;
    font-weight: 500;
    margin-bottom: 1rem;
    color: #333;

    @media (max-width: 768px) {
        font-size: 1.3rem;
    }
`;

const SectionContent = styled.div`
    line-height: 1.8;
    color: #666;
    font-size: 1rem;

    @media (max-width: 768px) {
        font-size: 0.9rem;
        line-height: 1.6;
    }
`;

const Terms: React.FC = () => {
    React.useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    return (
        <TermsContainer>
            <TermsContent>
                <TermsTitle>이용약관</TermsTitle>

                <TermsSection>
                    <SectionTitle>제1조 (목적)</SectionTitle>
                    <SectionContent>이 약관은 NO-ON(이하 "회사")이 제공하는 서비스의 이용과 관련하여 회사와 이용자 간의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.</SectionContent>
                </TermsSection>

                <TermsSection>
                    <SectionTitle>제2조 (정의)</SectionTitle>
                    <SectionContent>
                        1. "서비스"라 함은 회사가 제공하는 모든 서비스를 의미합니다.
                        <br />
                        2. "이용자"라 함은 회사의 서비스에 접속하여 이 약관에 따라 회사와 이용계약을 체결하고 회사가 제공하는 서비스를 이용하는 고객을 말합니다.
                    </SectionContent>
                </TermsSection>

                <TermsSection>
                    <SectionTitle>제3조 (약관의 효력 및 변경)</SectionTitle>
                    <SectionContent>
                        1. 이 약관은 서비스 화면에 게시하거나 기타의 방법으로 이용자에게 공지함으로써 효력이 발생합니다.
                        <br />
                        2. 회사는 필요한 경우 관련법령을 위배하지 않는 범위에서 이 약관을 변경할 수 있습니다.
                    </SectionContent>
                </TermsSection>

                <TermsSection>
                    <SectionTitle>제4조 (서비스의 제공)</SectionTitle>
                    <SectionContent>
                        회사는 다음과 같은 서비스를 제공합니다:
                        <br />
                        1. 동영상 콘텐츠 제공 서비스
                        <br />
                        2. 기타 회사가 정하는 서비스
                    </SectionContent>
                </TermsSection>

                <TermsSection>
                    <SectionTitle>제5조 (서비스 이용)</SectionTitle>
                    <SectionContent>
                        1. 이용자는 서비스를 자유롭게 이용할 수 있습니다.
                        <br />
                        2. 이용자는 서비스 이용 시 관련법령 및 이 약관을 준수해야 합니다.
                    </SectionContent>
                </TermsSection>

                <TermsSection>
                    <SectionTitle>제6조 (개인정보보호)</SectionTitle>
                    <SectionContent>회사는 관련법령이 정하는 바에 따라 이용자의 개인정보를 보호하며, 개인정보의 수집, 이용, 제공 등에 관한 사항은 개인정보처리방침에서 정합니다.</SectionContent>
                </TermsSection>

                <TermsSection>
                    <SectionTitle>제7조 (책임제한)</SectionTitle>
                    <SectionContent>회사는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 관한 책임이 면제됩니다.</SectionContent>
                </TermsSection>

                <TermsSection>
                    <SectionTitle>부칙</SectionTitle>
                    <SectionContent>이 약관은 2024년 1월 1일부터 시행합니다.</SectionContent>
                </TermsSection>
            </TermsContent>
        </TermsContainer>
    );
};

export default Terms;
